const amendingOrder = state => state.trolley.amendingOrder;

export default amendingOrder;
